import { ResponseParams, requestHttpGet } from './RequestBase';

/*
 * 1：表示＆必須入力
 * 2：表示＆任意入力
 * 3：非表示
 * 0：未使用（エラー）
 */
export type SiteDisplayItems = {
	id: number;
	search_site_cd: string;
	search_family_type: number;
	search_screen_id: string;
	gid: number;
	pass: number;
	mailaddress_1: number;
	mailaddress_2: number;
	mailaddress_3: number;
	mobile: number;
	lastname: number;
	firstname: number;
	kana_lastname: number;
	kana_firstname: number;
	birth: number;
	nickname: number;
	sex: number;
	country: number;
	zip: number;
	tel: number;
	pref_cd: number;
	address_2: number;
	address_3: number;
	address_4: number;
	address_5: number;
	address_6: number;
	family_cd: number;
	family_type: number;
	directmail_flg: number;
	payment_not_flg: number;
	withdrawal_flg: number;
	regist_ts: number;
	update_ts: number;
	tel_2: number;
	ext_1: number;
	ext_2: number;
	ext_3: number;
	data_util_agree_flg: number;
};
// サービスサイト別表示項目取得
export const callGetSiteDisplayItemsApi = async (siteCd: string): Promise<ResponseParams<SiteDisplayItems>> => {
	const result: ResponseParams<SiteDisplayItems> = await requestHttpGet(`/sites/display/item`, { site_cd: siteCd });
	return result;
};

export type GetSiteResData = {
	site_cd: string;
	site_name: string; // 表示用サイト名
	public_client_flg: number;
	claim_agreement_title: string;
	claim_agreement_description: string;
	claim_agreement_button_display_complete: string;
	bulk_payment_button_display_complete: string;
	need_claim_agreement_flg: number; // 1:必要, 0:不要
	scopes_supported_list: string[];
};
// サイト詳細取得
export const callGetSiteApi = async (siteCd: string): Promise<ResponseParams<GetSiteResData>> => {
	const result: ResponseParams<GetSiteResData> = await requestHttpGet(`/sites/${siteCd}`);
	return result;
};
